module.exports = __webpack_public_path__ + "img/uy.63023f30.svg";